import { useCallback } from "react";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { useFeatureTernary } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import {
  isPerformerCredibilityBadge,
  useWillShowPerformerCredibilityLabel,
} from "src/website-apps/shared/hooks/useWillShowPerformerCredibilityLabel";
import { MobileCredibilityBadgePlacement } from "./MobileCredibilityBadgePlacement";

export const resolveMobileCredibilityBadgePlacement = (value: number): MobileCredibilityBadgePlacement => {
  if (value === MobileCredibilityBadgePlacement.HERO) return MobileCredibilityBadgePlacement.HERO;
  if (value === MobileCredibilityBadgePlacement.BELOW_HERO) return MobileCredibilityBadgePlacement.BELOW_HERO;
  return MobileCredibilityBadgePlacement.CONTROL;
};

export const useMobileCredibilityBadgePlacementExperiment = (
  hasMobileHero: boolean,
): MobileCredibilityBadgePlacement => {
  const isMobile = !useMediaQuery(Breakpoint.Tablet);
  const labelType = useWillShowPerformerCredibilityLabel();
  const canParticipate = useCallback(
    () => isMobile && hasMobileHero && isPerformerCredibilityBadge(labelType),
    [hasMobileHero, isMobile, labelType],
  );
  const executeVariant = useFeatureTernary(FeatureSetEnum.TMPerformerCredibilityBadgePlacement, canParticipate);
  const assignedPlacement = executeVariant({
    control: () => MobileCredibilityBadgePlacement.CONTROL,
    variant: (_data, value) => resolveMobileCredibilityBadgePlacement(value),
  });

  if (!canParticipate()) return MobileCredibilityBadgePlacement.CONTROL;

  return assignedPlacement ?? MobileCredibilityBadgePlacement.CONTROL;
};
